export const staticText = {
  modules: {
    music: {
      label: "Music",
      discover: "Discover",
      library: "Library",
      connect: "Connect",
    },
    socialClearances: "Social Clearances",
    statements: "Statements",
    team: "Manage Team",
    manageOrganization: "Manage Organization",
    organizations: "My Organizations",
    manageTeam: "Manage Team",
    payouts: "Payouts",
    licenses: {
      label: "Licenses",
      commercialSubpage: "Commercial Licenses",
      librarySubpage: "Library Licenses",
    },
    legal: "Legal Agreements",
    resources: "Resources",
    creativeServices: "Creative Services",
    helpCenter: "Help Center",
    customerSupport: "Customer Support",
    profile: "Profile",
    signOut: "Log Out",
    labs: {
      label: "Labs",
      backButton: "Back to all apps",
    },
    musicIngestion: "Music Ingestion",
    distribution: "Distribution",
    reporting: "Reporting",
    statementImports: "Statement Imports",
    payoutAdministration: "Payout Administration",
  },
  features: {
    masterServiceAgreement: {
      surveyOptions: {
        1: "I need to manage my catalog considered for licensing",
        2: "I need more information about potential revenue streams",
        4: "The potential of new benefits in the agreement are unclear",
        8: "I need more information about the agreement",
        16: "I'm not interested now but I'm open to learning more",
        32: "I'm concerned about specific platforms or media where my music might be used",
        64: "There are additional rights holders consents that are needed",
        128: "Other Reason",
      },
    },
  },
};
